import React from 'react'
import { MenuItem, TextField } from '@mui/material'
import { ComponentProps } from '../../../types/filters'

export const WithAdjustmentsFilter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  variant = 'outlined'
}) => {
  return (
    <TextField
      variant={variant}
      id="withAdjustments"
      name="withAdjustments"
      select
      value={value || ''}
      onChange={onChange}
      fullWidth={fullWidth}
    >
      <MenuItem value="">
        Todos
      </MenuItem>
      <MenuItem value="true">
        Sí
      </MenuItem>
      <MenuItem value="false">
        No
      </MenuItem>
    </TextField>
  )
}
